/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { Component, type ReactNode } from 'react';
import DwellTimeHelperWithBrowserInteraction from '@atlassiansox/analytics-web-client/dwell-time-helper-with-browser-interaction';
import type {
	FireTrackAnalyticsPayload,
	AnalyticsDataPayload,
} from '@jira/platform__analytics-web-react/src/index.tsx';
import ComponentWithAnalytics from '@jira/platform__analytics-web-react/src/utils/component-with-analytics.tsx';
import { fireTrackAnalytics } from '@jira/platform__analytics-web-react/src/utils/fire-track-event.tsx';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next/withAnalyticsEvents';

type DwellData = AnalyticsDataPayload & {
	actionSubject: string;
	source: string;
};

export type Props = {
	data?: DwellData;
	children: ReactNode;
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	createAnalyticsEvent: any;
	sessionId: string;
};

// eslint-disable-next-line jira/react/no-class-components
export class DwellTime extends Component<Props> {
	componentDidMount(): void {
		const { data, sessionId } = this.props;
		// @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
		this.dwellHelper = new DwellTimeHelperWithBrowserInteraction(
			this.sendDwellEvent,
			data,
			sessionId,
		);
		// @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
		this.dwellHelper.start();
	}

	componentDidUpdate(oldProps: Props): void {
		if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) {
			// @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
			this.dwellHelper.newPage(this.props.data, this.props.sessionId);
		}
	}

	componentWillUnmount(): void {
		if (this.dwellHelper) {
			// @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
			this.dwellHelper.stop();
			// @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
			this.dwellHelper.destroy();
		}
	}

	sendDwellEvent = (payload: FireTrackAnalyticsPayload): void =>
		fireTrackAnalytics(this.props.createAnalyticsEvent(), payload);

	// @ts-expect-error - TS2564 - Property 'dwellHelper' has no initializer and is not definitely assigned in the constructor.
	dwellHelper: typeof DwellTimeHelperWithBrowserInteraction;

	render(): React.JSX.Element {
		return <>{this.props.children}</>;
	}
}

const ExportedComponent: React.FC<
	Omit<
		{
			data?: DwellData | undefined;
			children: ReactNode;
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			createAnalyticsEvent: any;
			sessionId: string;
			ref?: React.LegacyRef<DwellTime> | undefined;
			key?: React.Key | null | undefined;
		},
		keyof WithAnalyticsEventsProps
	>
> = ComponentWithAnalytics('dwellTime', {
	onDwell: 'dwelled',
})(DwellTime);
export default ExportedComponent;
